import React from 'react'
import Collapsible from 'react-collapsible'

import {
  AccountFragment,
  Category,
  PlanFragment,
  StripeSubscription,
} from 'src/graphql'
import { Feature as FeatureType, PlanFeature } from 'src/marketing/plans/types'
import {
  Feature,
  PlanTileGroup,
  PricingCell,
  RoundedFooter,
} from 'src/marketing/plans/components'

import { boxShadow, style } from './pricingTableStyles'

const cellStyle: React.CSSProperties = { minWidth: 0 }

export const discountDisclaimer = [
  '* Discounts apply to most gifts. Excludes: books, apparel, and business-building tools.',
  '** A Heartfelt Prompting Card has an immediate send date with only one recipient attached.',
  '*** An Automated Send card has a future send date or more than one recipient.',
]
const lastCategory = (index: number, categories: Category[]): boolean => {
  if (categories) {
    return index === categories.length - 1
  }
  return false
}

const isLastRow = (index: number, category: Category): boolean =>
  index === category.features.length - 1

type PricingTableProps = {
  account?: AccountFragment
  plans: PlanFragment[]
  categories: Category[]
  selectedColumn?: number
  onSelect: (plan: string) => void
  currentPlanId: string
  stripeSubscription?: Partial<StripeSubscription>
  getPlan: (planId: string) => PlanFragment | undefined
}

const PricingTable: React.FC<PricingTableProps> = props => {
  const showTable = false
  const {
    account,
    plans,
    categories,
    currentPlanId,
    onSelect,
    stripeSubscription,
    getPlan,
  } = props
  return (
    <React.Fragment>
      <PlanTileGroup
        account={account}
        plans={plans}
        currentPlan={currentPlanId}
        onSelect={onSelect}
        addSpacer={showTable}
        stripeSubscription={stripeSubscription}
        getPlan={getPlan}
      />
      <RoundedFooter
        open={showTable}
        messages={discountDisclaimer}
        actionTitle={showTable ? 'Hide Comparison' : 'View Comparison'}
        onClick={() => {}}
        isChartAvailable={false}
      />
      {showTable && (
        <Collapsible trigger="" open={showTable}>
          <div>
            {categories.map((category: Category, categoryIndex: number) => (
              <React.Fragment key={category.title}>
                <div style={style.categoryHeader}>{category.title}</div>
                {category.features.map(
                  (feature: FeatureType, index: number) => (
                    <div
                      key={feature.title}
                      style={{
                        display: 'flex',
                        marginBottom:
                          !lastCategory(categoryIndex, categories) &&
                          isLastRow(index, category)
                            ? 0
                            : 15,
                        boxShadow:
                          !lastCategory(categoryIndex, categories) &&
                          isLastRow(index, category)
                            ? 'unset'
                            : boxShadow,
                      }}
                    >
                      <Feature
                        id={index}
                        title={feature.title}
                        description={feature.description}
                      />
                      {feature.plans &&
                        feature.plans.map(
                          (planFeature: PlanFeature, index: number) => (
                            <PricingCell
                              key={index}
                              plan={planFeature}
                              planColor={planFeature.color ?? ''}
                              containerStyle={cellStyle}
                              currentPlan={
                                planFeature.plan
                                  ? currentPlanId === planFeature.plan
                                  : false
                              }
                            />
                          ),
                        )}
                    </div>
                  ),
                )}
              </React.Fragment>
            ))}
          </div>
        </Collapsible>
      )}
    </React.Fragment>
  )
}

export default PricingTable
